import { ItemNutritionType, ItemType, SubItemType } from "../../types";
import { getLocalizedString } from "../localization/localization";

/**
 * The single tag to render for an item, resolved for the active language.
 *
 * An item carries at most one tag, but the menu API returns an ordered list, so
 * take the first entry that actually has copy in a language we can show.
 */
export const getItemTagLabel = (
  item?: Pick<ItemType, "tags"> | null
): string | undefined => {
  if (!item?.tags?.length) {
    return undefined;
  }

  for (const tag of item.tags) {
    const label = getLocalizedString(tag.label);

    if (label) {
      return label.trim();
    }
  }

  return undefined;
};

type ItemNutritionDisplay = {
  calories?: number;
  allergens?: string;
};

/**
 * Calorie count and allergen list for the item page, resolved per variant.
 *
 * The selected sub-item wins whenever it carries its own value (a small combo
 * and a large combo differ), otherwise the item-level value is used.
 */
export const getItemNutrition = (
  item?: ItemNutritionType | null,
  selectedSubItem?: SubItemType | null
): ItemNutritionDisplay => {
  const calories = selectedSubItem?.calories ?? item?.calories;
  const allergens =
    getLocalizedString(selectedSubItem?.allergens) ??
    getLocalizedString(item?.allergens);

  return {
    calories: typeof calories === "number" ? calories : undefined,
    allergens: allergens?.trim() || undefined,
  };
};
